module.exports = __webpack_public_path__ + "img/logo_2.e702c50f.png";